import { Injectable } from '@angular/core';
import { compress, compressToUint8Array, decompress, decompressFromUint8Array } from 'lz-string';

@Injectable({
    providedIn: 'root',
})
export class LZStringService {
    /*
     * @deprecated use static method instead
     */
    public compress(data: string): string {
        return LZStringService.compress(data);
    }

    /*
     * @deprecated use static method instead
     */
    public compressToUint8Array(data: string): Uint8Array {
        return LZStringService.compressToUint8Array(data);
    }

    /*
     * @deprecated use static method instead
     */
    public decompress(compressed: string): string {
        return LZStringService.decompress(compressed);
    }

    /*
     * @deprecated use static method instead
     */
    public decompressFromUint8Array(data: Uint8Array): string {
        return LZStringService.decompressFromUint8Array(data);
    }

    public static compress(data: string): string {
        return compress(data);
    }

    public static compressToUint8Array(data: string): Uint8Array {
        return compressToUint8Array(data);
    }

    public static decompress(compressed: string): string {
        const decompressed = decompress(compressed);

        if (decompressed === null) {
            throw new Error(`LZStringService: decompress: Unable to decompress data!`);
        }
        return decompressed;
    }

    public static decompressFromUint8Array(data: Uint8Array): string {
        const decompressed = decompressFromUint8Array(data);

        if (decompressed === null) {
            throw new Error(`LZStringService: decompressFromUint8Array: Unable to decompress data!`);
        }
        return decompressed;
    }
}
